export const LOAD_SHIPPING_TYPE = 'LOAD_SHIPPING_TYPE';
export const SET_SHIPPING_TYPE_PAGINATION = 'SET_SHIPPING_TYPE_PAGINATION';
export const ADD_SHIPPING_TYPE = 'ADD_SHIPPING_TYPE';
export const EDIT_SHIPPING_TYPE = 'EDIT_SHIPPING_TYPE';
export const LOAD_EDITABLE_SHIPPING_TYPE = 'LOAD_EDITABLE_SHIPPING_TYPE';
export const SET_EDITABLE_SHIPPING_TYPE_DATA = 'SET_EDITABLE_SHIPPING_TYPE_DATA';
